import { useTranslation } from 'next-i18next';
import React from 'react';
import styled from 'styled-components';

interface InnerModalFiltersProps {
  filterName: string;
  children: React.ReactNode;
  closeFn: () => void;
}
const MobileInnerModalFiltersView = ({
  filterName,
  children,
  closeFn
}: InnerModalFiltersProps) => {
  const { t } = useTranslation('common');
  return (
    <Container>
      <h3>{filterName}</h3>
      <div className="child">{children}</div>
      <button onClick={closeFn}>{t('done')}</button>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${props => props.theme.light.colors.white};
  display: flex;
  flex-direction: column;
  align-items: center;

  h3 {
    font-family: materialBold;
    font-size: ${props => props.theme.font.sizes.xl};
    color: ${props => props.theme.light.colors.primaryBlue};
    margin-bottom: 8px;
  }

  .child {
    width: 100%;
    padding: 25px 16px;

    .multi-select {
      justify-content: center;
    }
  }

  button {
    width: 134px;
    height: 44px;
    font-family: materialMedium;
    font-size: ${props => props.theme.font.sizes.l};
    background-color: ${props => props.theme.light.colors.white};
    border-radius: ${props => props.theme.borderRadius};
    border: 1px solid ${props => props.theme.light.colors.secondaryBlue};
    color: ${props => props.theme.light.colors.secondaryBlue};
  }
`;
export default MobileInnerModalFiltersView;
